export const OwlLogo = ({ className = "w-9 h-9", variant = "square" }) => (
  <svg viewBox="0 0 64 64" className={className} role="img" aria-label="Logo Chouette Apprentissage" data-testid="owl-logo">
    {variant === "square" && <rect width="64" height="64" rx="14" fill="#F6BE3C" />}
    <path d="M16 12 L27 23 L13 27 Z" fill="#8A5A2E" />
    <path d="M48 12 L51 27 L37 23 Z" fill="#8A5A2E" />
    <circle cx="23" cy="33" r="10.5" fill="#FDFBF7" />
    <circle cx="41" cy="33" r="10.5" fill="#FDFBF7" />
    <circle cx="23" cy="33" r="4.4" fill="#33251A" />
    <circle cx="41" cy="33" r="4.4" fill="#33251A" />
    <circle cx="24.7" cy="31.2" r="1.5" fill="#FDFBF7" />
    <circle cx="42.7" cy="31.2" r="1.5" fill="#FDFBF7" />
    <path d="M32 39 L27 45.5 Q32 50 37 45.5 Z" fill="#F2A33C" />
  </svg>
);

export default OwlLogo;